import React from "react";
import PropTypes from "prop-types";

import Box from "../box/index.js";

import styles from "./styles.module.scss";

const Button = ({
  buttonType = "button",
  className = null,
  element = "button",
  icon = null,
  label = null,
  onClick = () => {},
  path = null,
  size = "medium",
  width = "auto",
  ...props
}) => {
  let refineProps = { ...props };
  delete refineProps.buttonType;
  delete refineProps.icon;
  delete refineProps.label;
  delete refineProps.path;

  const content = (
    <>
      {icon && icon}
      {label && label}
    </>
  );

  const buttonClassName = `${styles.buttonOrLink} ${
    className ? className : ""
  }`;

  if (buttonType === "anchor") {
    return (
      <Box
        className={buttonClassName}
        data-button-type={buttonType}
        element="a"
        href={path}
        size={size}
        width={width}
        {...refineProps}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      className={buttonClassName}
      data-button-type={buttonType}
      element={element}
      onClick={onClick}
      size={size}
      width={width}
      {...refineProps}
    >
      {content}
    </Box>
  );
};

Button.propTypes = {
  buttonType: PropTypes.oneOf(["anchor", "button"]),
  className: PropTypes.string,
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  icon: PropTypes.element,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  path: PropTypes.string,
  width: PropTypes.oneOf(["auto", "full"])
};

export default Button;
